export default {
  IN_PRODUCTION: 'En production',
  WAITING_RESPONSE: 'En attente',
  CANCELED: 'Annuler',
  COMPLETED: 'Fini',
}
